import { Optional } from '../types/generic';

/**
 */

type CookieOptions = {
  name: string;
  value: string;
  path?: string;
  domain?: string;
  maxAge?: number;
  secure?: boolean;
  sameSite?: 'none' | 'lax' | 'strict';
};

export const saveCookie = ({
  name,
  value,
  path,
  domain,
  maxAge,
  secure,
  sameSite,
}: CookieOptions): void => {
  let cookie = `${name}=${value}`;

  if (path) {
    cookie += `;path=${path}`;
  }

  if (domain) {
    cookie += `;domain=${domain}`;
  }

  if (maxAge) {
    cookie += `;max-age=${maxAge}`;
  }

  if (secure) {
    cookie += `;secure`;
  }

  if (sameSite) {
    cookie += `;samesite=${sameSite}`;
  }

  window.document.cookie = cookie;
};

/**
 * Load from cookie by name. Does not decode the value.
 */
export const loadCookie = (name: string, cookieString?: string): Optional<string> => {
  const cookieSrc = cookieString ?? window.document.cookie;
  const value = `; ${cookieSrc}`;
  const parts = value.split(`; ${name}=`);
  return (parts.length === 2 ? parts.pop()?.split(';')?.[0] : null) as Optional<string>;
};

/**
 * Clear related cookie.
 */
export const clearCookie = (name: string, path = '/'): void => {
  window.document.cookie = `${name}=; Path=${path}; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
};

/**
 * Checks if a cookie with the specified name and optional value exists
 */
export const hasCookie = (name: string, value = ''): boolean => {
  if (typeof document === 'undefined') return false;
  const cookies = document.cookie.split(';').map((cookie) => cookie.trim());
  return cookies.some((cookie) => cookie.startsWith(`${name}=${value}`));
};
